import { Fragment } from 'react'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Radio as MuiRadio, FormControlLabel } from '@mui/material'

import SwitchLabel from '../switchLabel'

import { Box } from '@mui/system'

import useStyles from './styles'
import Divider from '../divider'

const Radio = ({
  label,
  subLabel,
  additionalText,
  disabled,
  multiline = true,
  amount,
  className,
  ...other
}) => {
  const classes = useStyles()

  const FormControlLabelWrapperWithAmount = ({ children }) => (
    <Box className={classes.formControlLabelWrapperWithAmount}>{children}</Box>
  )
  FormControlLabelWrapperWithAmount.propTypes = {
    children: PropTypes.node,
  }

  const FormControlLabelWrapper = amount
    ? FormControlLabelWrapperWithAmount
    : Fragment
  return (
    <FormControlLabelWrapper>
      <FormControlLabel
        className={clsx(className, classes.container)}
        label={
          <SwitchLabel
            checked={other.checked}
            label={label}
            subLabel={subLabel}
            additionalText={additionalText}
            disabled={disabled}
            multiline={multiline}
            amount={amount}
          />
        }
        control={<MuiRadio />}
        disabled={disabled}
        {...other}
      />
      {amount ? <Divider hasSmallDots /> : null}
    </FormControlLabelWrapper>
  )
}

Radio.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  additionalText: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  amount: PropTypes.number,
}

export default Radio
